export class AccCategoryResultDto {
  id: number;
  name: string;
}
